import storage from '@/utils/storage'
import { IS_PROD } from '@/config'

type FlagLookup = (flag: string) => boolean
type FlagSetter = (enabled: boolean) => void

type NeatNameSpace = {
  flag: FlagLookup
  skipRecaptcha: FlagSetter
  testRecaptchaScriptError: FlagSetter
}

declare global {
  interface Window {
    neat: NeatNameSpace
  }
}

const PREFIX = 'neat'
const SKIP_RECAPTCHA = `${PREFIX}::skipRecaptcha`
const TEST_RECAPTCHA_SCRIPT_ERROR = `${PREFIX}::testRecaptchaScriptError`

const neat = {
  flag: (flag: string) => {
    switch (flag) {
      case 'skipRecaptcha':
        return !!storage.get(SKIP_RECAPTCHA)
      case 'testRecaptchaScriptError':
        return !!storage.get(TEST_RECAPTCHA_SCRIPT_ERROR)
      default:
        return false
    }
  },
  skipRecaptcha: (flag: boolean) => (flag ? storage.set(SKIP_RECAPTCHA, 'true') : storage.remove(SKIP_RECAPTCHA)),
  testRecaptchaScriptError: (flag: boolean) =>
    flag ? storage.set(TEST_RECAPTCHA_SCRIPT_ERROR, 'true') : storage.remove(TEST_RECAPTCHA_SCRIPT_ERROR),
}

export const getShouldSkipRecaptcha = (isMobileClient = false) => {
  if (IS_PROD) return false
  return !!storage.get(SKIP_RECAPTCHA) || (isMobileClient && process.env.NEXT_PUBLIC_SKIP_RECAPTCHA_MOBILE === 'true')
}

if (typeof window !== 'undefined') {
  window.neat = neat
}

export default neat
